
import {Component, Vue, Watch} from 'vue-property-decorator';
import ImportHistory from '@/data/models/importHistory';

/**
 * Onglet « Imports » : historique des imports de données.
 * Filtres conservés dans l'URL (?showSuccess, ?showNoData) pour le rechargement.
 */
@Component({})
export default class AdminImportLogs extends Vue {
  headers = [
    {text: 'Nom du fichier', value: 'filename'},
    {text: 'Type', value: 'type', sortable: false},
    {text: 'Date', value: 'createat'},
    {text: 'Données', value: 'raw', sortable: false},
    {text: '', value: 'action', align: 'right', sortable: false},
  ];

  logs: Array<ImportHistory> = [];
  retrying: { [id: string]: boolean } = {};
  // Contenu affiché dans la fenêtre « Résultat » / « Données »
  preview: { title: string, content: string, loading?: boolean } = null;
  loading = false;
  showSuccess = this.$route.query.showSuccess === 'true';
  showNoData = this.$route.query.showNoData === 'true';
  // Fichiers masqués (ex. « AMT|weather » masque les noms contenant AMT ou weather, sans tenir compte de la casse)
  filter = 'AMT|weather';

  @Watch('showSuccess')
  onShowSuccessChange(value: boolean): void {
    this.updateQuery({showSuccess: value.toString()});
    this.getLogs();
  }

  @Watch('showNoData')
  onShowNoDataChange(value: boolean): void {
    this.updateQuery({showNoData: value.toString()});
  }

  mounted(): void {
    this.getLogs();
  }

  updateQuery(values: Record<string, string>): void {
    this.$router.replace({query: {...this.$route.query, ...values}}).catch(() => undefined);
  }

  get logsFiltered(): Array<ImportHistory> {
    const toFilter = (this.filter || '').split('|').map((item) => item.toLowerCase().trim()).filter((it) => it);
    return this.logs.filter((log) => {
      return (this.showSuccess || !log.success) && (this.showNoData || !log.hasNoData) && !toFilter.some((filter) => log.filename.toLowerCase().includes(filter));
    });
  }

  getLogs(): void {
    this.loading = true;
    this.$dao.logs.getAll(this.showSuccess).then((logs: Array<ImportHistory>) => {
      logs.sort((a, b) => b.createat.getTime() - a.createat.getTime());
      this.logs = logs;
    }).finally(() => this.loading = false);
  }

  retry(id: string): void {
    this.$set(this.retrying, id, true);
    this.$dao.logs.replay(id).then(() => {
      this.getLogs();
      this.$set(this.retrying, id, false);
    }).catch(() => {
      this.$dialog.error({text: 'Une erreur est survenue', title: 'Erreur'});
      this.$set(this.retrying, id, false);
    });
  }

  show(item: ImportHistory, element: string): void {
    if (element === 'results') {
      this.preview = {title: `Résultat — ${item.filename}`, content: JSON.stringify(item.results, null, 2)};
    } else {
      // Contenu brut chargé à la demande : les listes ne le renvoient pas
      const preview = {title: `Données — ${item.filename}`, content: '', loading: true};
      this.preview = preview;
      this.$dao.logs.getRaw(item.id)
          .then((raw) => preview.content = raw)
          .catch(() => this.$dialog.error({text: 'Impossible de charger les données', title: 'Erreur'}))
          .finally(() => preview.loading = false);
    }
  }

  copyPreview(): void {
    navigator.clipboard.writeText(this.preview.content).then(() => this.$dialog.notify.success('Données copiées'));
  }
}
